<template>
<div class="vm-row">

    <slot></slot>

</div>
</template>
<script>

export default {
name: 'vm-row',
props: {
    
},
data() {
    return {
        
    }
}
}
</script>
<style scoped>

.vm-row {
    float: left;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    box-sizing: border-box;
}

</style>
